import { db } from "@/firebase/init";

export default {
  namespaced: true,
  state: {
    alternateEmail: '',
    migrationCount: 0,
    savedMigrationCount:0,
    addonCount: 0,
    planIndex: null,
    dnsManagedByBigscoots: true,
    migrationLimit: {
      starter: 1,
      professional: 3,
      business: 10,
      enterprise: 50,
      vps: 3,
      dedicated: 10
    },
    addonDomainLimit: 0,
    migrationList: [],
    cloudflare: {
      haveAcc: false,
      email: "",
      password: "",
      type: 'Cloudflare',
    },
    haveSpecialRewrites: false,
    isMAndC: false,
    mOrC: '',
    rewriteRule: "",
    specialInstruction: "",
    useEmailOnDomain: false,
    haveGsuite: true,
    moveEmailToBigscoots: false,
    emailSpecialRequest: "",
    doAddCollaborator: false,
    hostVideoAccessResponseFlag: true,
    addedCollaborators: []
  },
  getters: {
    getAddedCollaborators (state) {
      return state.addedCollaborators;
    },
    shouldAddCollaborator (state) {
      return state.doAddCollaborator;
    },
    getHostVideoAccessResponseFlag (state) {
      return state.hostVideoAccessResponseFlag;
    },
    isMAndC (state) {
      return state.isMAndC;
    },
    mOrC (state) {
      return state.mOrC;
    },
    alternateEmail (state) {
      return state.alternateEmail;
    },
    planIndex(state) {
      return state.planIndex;
    },
    count(state) {
      return state.migrationCount;
    },
    addonCount(state) {
      return state.addonCount;
    },
    limit(state) {
      return state.migrationLimit;
    },
    savedMigrationCount(state) {
      return state.savedMigrationCount
    },
    addonLimit(state) {
      return state.addonDomainLimit;
    },
    migrationList(state) {
      return state.migrationList
    },
    dnsByBigscoots(state) {
      return state.dnsManagedByBigscoots
    },
    haveCloudflare(state) {
      return state.cloudflare.haveAcc
    },
    cdnType(state) {
      return state.cloudflare.type;
    },
    cfEmail(state) {
      return state.cloudflare.email
    },
    cfPass(state) {
      return state.cloudflare.password
    },
    haveSpecialRewriteRule(state) {
      return state.haveSpecialRewrites
    },
    rewriteRule(state) {
      return state.rewriteRule
    },
    specialInstruction(state) {
      return state.specialInstruction
    },
    useEmailOnDomain(state) {
      return state.useEmailOnDomain
    },
    haveGsuite(state) {
      return state.haveGsuite
    },
    moveEmailToBigscoots(state) {
      return state.moveEmailToBigscoots
    },
    emailSpecialRequest(state) {
      return state.emailSpecialRequest
    }
  },
  mutations: {
    mutateAddedCollaborators (state, payload) {
      state.addedCollaborators = payload;
    },
    mutateAddCollaborator (state, payload) {
      state.doAddCollaborator = payload;
    },
    mutateHostVideoAccessResponseFlag (state, payload) {
      state.hostVideoAccessResponseFlag = payload;
    },
    mutateIsMAndC (state, payload) {
      state.isMAndC = payload;
    },
    mutateMOrC (state, payload) {
      state.mOrC = payload;
    },
    mutateAlternateEmail (state, payload) {
      state.alternateEmail = payload
    },
    planIndexMutate(state, payload) {
      state.planIndex = payload.index;
    },
    countMutate(state, payload) {
      state.migrationCount = payload.count;
    },
    savedMigrationCount(state, payload){
      state.savedMigrationCount=payload.count;
    },
    addonLimitMutate(state, payload) {
      state.addonDomainLimit = payload.limit;
    },
    addonCountMutate(state, payload) {
      state.addonCount = payload.count;
    },
    migrationListMutate(state, payload) {
      state.migrationList = payload.list
    },
    dnsByBigscootsMutate(state, payload) {
      state.dnsManagedByBigscoots = payload.state
    },
    haveCloudflareMutate(state, payload) {
      state.cloudflare.haveAcc = payload.state
    },
    cdnTypeMutate(state, payload) {
      state.cloudflare.type = payload;
    },
    cfEmailMutate(state, payload) {
      state.cloudflare.email = payload.email
    },
    cfPassMutate(state, payload) {
      state.cloudflare.password = payload.password
    },
    haveSpecialRewriteRuleMutate(state, payload) {
      state.haveSpecialRewrites = payload.state
    },
    rewriteRuleMutate(state, payload) {
      state.rewriteRule = payload.rule
    },
    specialInstructionMutate(state, payload) {
      state.specialInstruction = payload.details
    },
    useEmailOnDomainMutate(state, payload) {
      state.useEmailOnDomain = payload.state
    },
    haveGsuiteMutate(state, payload) {
      state.haveGsuite = payload.state
    },
    moveEmailToBigscootsMutate(state, payload) {
      state.moveEmailToBigscoots = payload.state
    },
    emailSpecialRequestMutate(state, payload) {
      state.emailSpecialRequest = payload.request
    },
    reset(state) {
      state.migrationCount = 0
      state.savedMigrationCount=0
      state.addonCount = 0
      state.planIndex = null,
      state.dnsManagedByBigscoots = true
      state.addonDomainLimit = 0
      state.migrationList = []
      state.cloudflare = {
        haveAcc: false,
        type: 'Cloudflare',
        email: "",
        password: ""
      }
      state.haveSpecialRewrites = false
      state.rewriteRule = ""
      state.specialInstruction = ""
      state.useEmailOnDomain = false
      state.haveGsuite = true
      state.moveEmailToBigscoots = false;
      state.doAddCollaborator = false;
      state.addedCollaborators = [];
      state.isMAndC = false;
    }
  },
  actions: {
    planIndexUpdate(context, payload) {
      context.commit("planIndexMutate", payload);
    },
    countUpdate(context, payload) {
      context.commit("countMutate", payload);
    },
    addonCountUpdate(context, payload) {
      context.commit("addonCountMutate", payload);
    },
    countUpdateDB(context, payload) {
      // Set asyncDone to false
      context.dispatch("async/stateUpdate", { state: false }, { root: true });

      let UserUID = context.rootGetters.getUID;

      if(payload && payload.UID){
        UserUID = payload.UID
      }

      db.collection("hostingAccounts")
        .doc(UserUID)
        .get()
        .then(doc => {
          const accounts = doc.data().accounts;
          const selectedPlan = accounts.filter((acc, index) => {
            return context.state.planIndex === index;
          });

					// IMPORTANT: Now we will increase the counter by 1 initially anyways
					// Reason: When the user will go to the migration page, the first field will be there anyways.
					// So, the user can always just fill that field and proceed. So, we are assuming that the user
					// will always fill that field and that's why increasing the counter by 1 initially.
					// Then if the user click on ADD MORE MIGRATION site it will keep getting increased
          const count = selectedPlan[0].migration.count + 1;
          const addonLimit = Number(selectedPlan[0].planLimit) + Number(selectedPlan[0].extraDomains);
          const addonCount = selectedPlan[0].addon.length;

          context.commit("savedMigrationCount", { count: selectedPlan[0].migration.count });
          context.commit("countMutate", { count: count });
          context.commit("addonCountMutate", { count: addonCount });
          context.commit("addonLimitMutate", { limit: addonLimit });

          // Set asyncDone to true
          context.dispatch(
            "async/stateUpdate",
            { state: true },
            { root: true }
          );
        })
        .catch(err => {
          // Set asyncDone to true
          context.dispatch(
            "async/stateUpdate",
            { state: true },
            { root: true }
          );

          // Show error message for 5 sec
          context.dispatch(
            "alert/update",
            {
              type: "danger",
              message: err.message,
              show: true
            },
            { root: true }
          );

          setTimeout(() => {
            context.dispatch(
              "alert/showUpdate",
              { show: false },
              { root: true }
            );
          }, 5000);
        });
    },
    migrationListUpdate(context, payload) {
      context.commit("migrationListMutate", payload)
    }
  }
};
